import React from "react";
import { useAppSelector } from "../../redux/configureStore";
import OT from "@opentok/client";
import RecordingIcon from "./RecordingIcon";
import SessionVideoSubscriberStream from "./SessionVideoSubscriberStream";
import SubscriberControls from "./SubscriberControls";
import useUpdateComposedLayout from "./presenting/useUpdateComposedLayout";
import { getTalker } from "./selectors";
import useStreamLayout from "./useStreamLayout";
import useStreams from "./useStreams";
import { VenueSessionState } from "../../app/types";
import { useJoinData, useSession } from "../api/helpers";
import useDivDimensions from "../common/useDivDimensions";

interface Props {
  vonageSession: OT.Session;
  sessionState: VenueSessionState;
}

const SessionVideoStreams = ({ vonageSession, sessionState }: Props) => {
  const streamRef = React.createRef<HTMLDivElement>();

  const joinData = useJoinData();
  const session = useSession();
  const talker = useAppSelector(getTalker(session?.sessionId));

  const streamDimensions = useDivDimensions(streamRef);
  const streams = useStreams(vonageSession, sessionState);

  const layout = useStreamLayout(
    streams,
    streamDimensions.width,
    streamDimensions.height,
  );

  useUpdateComposedLayout(streams);

  return (
    <div ref={streamRef} className="streams">
      {layout !== null &&
        streams.map((stream) => (
          <SessionVideoSubscriberStream
            box={layout[stream.streamId]}
            key={stream.streamId}
            stream={stream}
            vonageSession={vonageSession}
            isTalker={talker === stream.streamId}
          />
        ))}
      {sessionState === "subscribing" && <SubscriberControls />}
      {joinData?.isRecorded === true && session?.status === "InProgress" && (
        <div className="overlay">
          <RecordingIcon />
        </div>
      )}
      <style jsx>{`
        .streams {
          width: 100%;
          height: 100%;
        }
        .overlay {
          position: absolute;
          top: 10px;
          left: 10px;
        }
      `}</style>
    </div>
  );
};

export default SessionVideoStreams;
